import React, { useEffect, useState } from "react";
import AdminContainer from "../../components/ui/AdminContainer";
import Button from "../../components/ui/Button";
import RemoteTable from "../../components/ui/RemoteTable";
import http from "../../services/httpServices";
// import { isMultiYear } from "../../services/defaultSettings";
// import { getYearPlaceHolder } from "../../services/yearSevices";
import { printFullDate } from "../../utils/time";
import InputField from "../../components/form/elements/InputField";
import { handleInputChange } from "../../services/formServices";
import auth from "../../services/authServices";
import { Link } from "react-router-dom";

const TeacherAdminExamResultsTable = () => {
    let columns = [
        {
            name: "التسلسل",
            reorder: true,
            selector: (row) => row.id,
            sortable: true,
            sortField: "id",
        },
        {
            name: "اسم الطالب",
            reorder: true,
            selector: (row) => row.user.full_name,
        },
        {
            name: "رقم هاتف الطالب",
            reorder: true,
            selector: (row) => (
                <Link
                    className="block px-1 py-1 text-center underline"
                    element="Link"
                    to={`../user_profile/${row.user.id}`}
                >
                    0{row.user.phone}
                </Link>
            ),
        },
        {
            name: "رقم هاتف ولى الأمر",
            reorder: true,
            selector: (row) => <span>0{row.user.father_phone}</span>,
        },
        {
            name: "اسم الامتحان",
            reorder: true,
            selector: (row) => row.exam.name,
            sortable: true,
            sortField: "exam_id",
        },
        {
            name: "عدد الاسئلة",
            reorder: true,
            selector: (row) => row.questions_quantity,
            sortable: true,
            sortField: "questions_quantity",
        },
        {
            name: "النتيجة",
            reorder: true,
            selector: (row) => `${Math.round((row.result / row.full_result) * 100)} %`,
            sortable: true,
            sortField: "result",
        },
        {
            name: "الدرجة",
            reorder: true,
            selector: (row) => `${row.result} من ${row.full_result}`,
            sortable: true,
            sortField: "result",
        },
        {
            name: "عدد الاسئلة المحلولة",
            reorder: true,
            selector: (row) => row.is_selected_count,
            sortable: true,
            sortField: "is_selected_count",
        },
        {
            name: "عدد الاسئلة الصحيحة",
            reorder: true,
            selector: (row) => row.is_correct_answers_count,
            sortable: true,
            sortField: "is_correct_answers_count",
        },
        // {
        //     name: "الاجابات",
        //     reorder: true,
        //     selector: (row) => (
        //         <Button
        //             className="block px-1 py-1 text-center"
        //             element="Link"
        //             to={`../user_profile/exam_results/${row.id}`}
        //         >
        //             عرض الاجابات
        //         </Button>
        //     ),
        //     // sortable: true,
        //     // sortField: "questions_quantity",
        // },
        {
            name: "وقت انهاء الامتحان",
            reorder: true,
            selector: (row) => printFullDate(row.updated_at),
            sortable: true,
            sortField: "updated_at",
        },
        {
            name: "وقت بدأ الامتحان",
            reorder: true,
            selector: (row) => printFullDate(row.created_at),
            sortable: true,
            sortField: "created_at",
        },
    ];

    const initialState = {
        full_name: "",
        phone: "",
        exam_id: 0,
    };

    const [filterData, setFilterData] = useState(initialState);
    const [data, setData] = useState(initialState);

    const [exams, setExams] = useState([]);
    const getExams = async () => {
        const token = auth.getTeacherToken();
        const config = auth.getAdminAuthConfig(token);

        const { data: response } = await http.get(`/api/teacher_admin_panel/exams/options`, config);
        setExams(response);
    };
    useEffect(() => {
        // eslint-disable-next-line eqeqeq
        if (data.division_id != 0) {
            getExams();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data.division_id]);

    return (
        <AdminContainer>
            <div className="w-full space-y-6">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-4 gap-y-6 w-full">
                    <InputField
                        id="full_name"
                        placeholder="اسم الطالب"
                        onChange={handleInputChange}
                        data={data}
                        setData={setData}
                    />
                    <InputField
                        id="phone"
                        placeholder="رقم هاتف الطالب"
                        onChange={handleInputChange}
                        data={data}
                        setData={setData}
                    />
                    <InputField
                        id="exam_id"
                        type="select"
                        placeholder="اختر الامتحان"
                        options={[
                            {
                                value: 0,
                                text: "كل الامتحانات",
                            },
                            ...exams,
                        ]}
                        onChange={handleInputChange}
                        data={data}
                        setData={setData}
                    />
                </div>
                <Button
                    className="w-full"
                    color="blue"
                    onClick={() => {
                        setFilterData(data);
                    }}
                >
                    بحث
                </Button>
                <RemoteTable
                    api={`/api/teacher_admin_panel/exam_results/exam/paginate`}
                    columns={columns}
                    isAdmin={false}
                    isTeacherAdmin={true}
                    filterData={filterData}
                />
            </div>
        </AdminContainer>
    );
};

export default TeacherAdminExamResultsTable;
